/**
 * ULID без зависимостей: 48 бит времени + 80 бит случайности,
 * Crockford base32. Сортируемость по времени — то, что нужно
 * журналу событий кассы.
 */
const B32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function ulid(now = Date.now()): string {
  let t = now;
  let time = '';
  for (let i = 0; i < 10; i++) {
    time = B32[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const rnd = crypto.getRandomValues(new Uint8Array(16));
  let rand = '';
  for (let i = 0; i < 16; i++) rand += B32[rnd[i]! % 32];
  return time + rand;
}
